import React from 'react';

import {Icon} from '@udemy/icons';
import {ExpressiveIcon} from '@udemy/icons-expressive';

import styles from './certificate-banner.module.less';

export const CertificateBanner = () => (
    <div className={styles['certificate-banner']}>
        <div className={styles['certificate-banner-image']}>
            <ExpressiveIcon name="certificate" loading="lazy" />
        </div>

        <div className={styles['certificate-banner-content']}>
            <div className="ud-heading-lg">{gettext('Showcase your new skills')}</div>
            <div className={styles['certificate-banner-text']}>
                {gettext(
                    'Career Accelerators courses include certificates of completion you can add to your resume, portfolio, or LinkedIn profile.',
                )}
            </div>
            <div className={styles['banner-social-media']}>
                <Icon name="facebook-icon" label="" glyph="facebook" size="medium" />
                <Icon name="twitter-x-icon" label="" glyph="twitter" size="medium" />
            </div>
        </div>
    </div>
);
